import React from "react";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import {
    clearTradeInAemExtData,
    setTradeInAemShowModal,
} from "../../../../../../../../common-deprecated/features/tradein/redux/actions/TradeInAemExternalDataActions";
import Button from "../../../../../../shared-components/css-modules/lexus/atoms/Button";
import { type CarConfigDispatchType, useCarConfigSelector } from "../../../../../redux/store";
import { formatPriceIntl } from "../../../../../../../../common-deprecated/priceUtils";
import Icon from "../../../../../../shared-components/css-modules/lexus/atoms/Icon";
import styles from "../Summary.module.scss";
import a11y from "../../../../../../shared-components/css-modules/lexus/utils/Accessibility.module.scss";
import { trackOrderOpenTradeIn } from "../../../../../utils/tracking";
import { CarConfigLabel } from "../../../../../utils/labelUtils";
import { useDispatch } from "../../../../../../../../shared-logic/redux/store";

const SummaryIntegratedTradeIn = (): JSX.Element | null => {
    const dispatch = useDispatch<CarConfigDispatchType>();
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const externalData = useCarConfigSelector((state) => state.tradeInAemExternalData);
    const financeOption = useCarConfigSelector((state) => state.utils.financeOption);

    const showValuation = !!externalData.data.vehicleValue && !externalData.notification[financeOption].isError;
    const formattedPrice = formatPriceIntl(commonSettings, -(externalData.data.vehicleValue || 0)).primaryPrice;

    return (
        <li className={styles["config-subitem"]}>
            <div className={styles["config-subitem-title"]}>
                {showValuation ? (
                    <div>
                        <Text tag="h3" variant="apheleia-body">
                            <strong>
                                <CarConfigLabel label="carConfigPartExchange" />
                            </strong>
                        </Text>
                        <Text variant="apheleia-body">{externalData.data.vehicleName?.name} </Text>
                        <Text variant="apheleia-body">{externalData.data.vehicleName?.description}</Text>
                        <Text variant="apheleia-body">{externalData.data.licensePlate}</Text>
                    </div>
                ) : (
                    <Text tag="h4" variant="apheleia-body">
                        <CarConfigLabel label="carConfigPartExchange" />
                    </Text>
                )}
            </div>
            <div className={styles["config-subitem-price"]}>
                {showValuation ? (
                    <div className={styles["trade-in-price"]}>
                        <Text variant="apheleia-body" className={styles["trade-in-price-label"]}>
                            {formattedPrice}
                        </Text>
                        <Button
                            variant="clean"
                            onClick={() => {
                                trackOrderOpenTradeIn();
                                dispatch(setTradeInAemShowModal(true));
                            }}
                        >
                            <Icon variant="edit" sizing="xs" aria-hidden="true" />
                            <span className={a11y["sr-only"]}>
                                <CarConfigLabel label="carConfigEditPartExchange" />
                            </span>
                        </Button>
                        <Button variant="clean" onClick={() => dispatch(clearTradeInAemExtData())}>
                            <Icon variant="minus" sizing="sm" aria-hidden="true" />
                            <span className={a11y["sr-only"]}>
                                <CarConfigLabel label="carConfigRemovePartExchange" />
                            </span>
                        </Button>
                    </div>
                ) : (
                    <Button
                        variant="apheleia-text"
                        onClick={() => {
                            trackOrderOpenTradeIn();
                            dispatch(setTradeInAemShowModal(true));
                        }}
                    >
                        <CarConfigLabel label="carConfigAddPartExchange" />
                    </Button>
                )}
            </div>
        </li>
    );
};

export default SummaryIntegratedTradeIn;
